import { render, staticRenderFns } from "./painting.vue?vue&type=template&id=1800cd21&scoped=true"
import script from "./painting.vue?vue&type=script&lang=js"
export * from "./painting.vue?vue&type=script&lang=js"
import style0 from "./painting.vue?vue&type=style&index=0&id=1800cd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1800cd21",
  null
  
)

export default component.exports